import { useTranslation } from '@oaknorth/util-intl';

import { Select } from './Select';
import { SelectItem, SelectItemSelectProps } from './types';

/**
 * A wrapper for Select that allows you to pass options that are not objects.
 * React select requires the options to be objects, so this component will map non-object
 * options to a SelectItem array using the provided getOptionLabel, getOptionValue, and value props
 * and then render them in a Select. You must provide the rest of the Select's props
 * assuming that the options will be select items (SelectItem<OptionType>)
 */
export const SelectItemSelect = <OptionType, IsMultiSelect extends boolean>({
  getOptionLabel: getOptionLabelProp,
  getOptionValue: getOptionValueProp,
  ...props
}: SelectItemSelectProps<OptionType, IsMultiSelect>) => {
  const { i18n } = useTranslation();

  const getOptionLabel = (option: SelectItem<OptionType>) => i18n.stringify(getOptionLabelProp(option.data));

  const getOptionValue = (option: SelectItem<OptionType>) => option.value;

  return (
    <Select<SelectItem<OptionType>, IsMultiSelect>
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      {...props}
    />
  );
};
